import React, { useRef } from "react";
import { useNavigate } from "react-router-dom";
import ProgressStep from "../../common/ProgressStep";
import Button from "../../common/Button";

const CtaSection = () => {
  const navigate = useNavigate();
  const firstNameRef = useRef(null);

  const navigateToForm = (e) => {
    e.preventDefault();
    const params = new URLSearchParams(window.location.search);
    const utm_source = params.get("utm_source") || "";
    const utm_medium = params.get("utm_medium") || "";
    const utm_campaign = params.get("utm_campaign") || "";

    navigate("/form", {
      state: {
        first_name: firstNameRef.current?.value.trim(),
        utm_source,
        utm_medium,
        utm_campaign,
      },
    });
  };

  return (
    <section className="pb-20 md:pb-40 container inline-padding">
      <div className="px-4 md:px-16 py-6 md:py-12 flex flex-col md:flex-row md:items-center justify-between gap-8 bg-m_cta-section-bg md:bg-d_cta-section-bg bg-cover bg bg-no-repeat rounded-2xl overflow-hidden">
        <div className="max-w-[400px] 2xl:max-w-[450px]">
          <h3 className="text-white mb-2">
            Unlock Exclusive Discounts Instantly!
          </h3>
          <p className="b3 text-grey-01">
            Fill out the form to instantly receive our PDF packed with special
            deals on HPE ProLiant Gen12 servers.
          </p>
        </div>
        <div className="w-full max-w-full md:max-w-[400px] bg-white p-6 rounded-lg">
          <form onSubmit={navigateToForm} className="flex flex-col gap-y-8">
            <div>
              {/* <h3 className="text-white mb-4">Get Discounted products!</h3> */}
              <div className="flex items-center gap-1 mb-4">
                <ProgressStep className="bg-blue-05" />
                <ProgressStep className="bg-blue-02" />
              </div>
              <div className="flex flex-col gap-1">
                <label className="b4 text-blue-04">First name</label>
                <input
                  ref={firstNameRef}
                  placeholder="Enter your name"
                  className="px-4 py-3 input-field text-grey-04 bg-grey-01 outline-none border border-transparent rounded hover:border-[1.5px] hover:border-blue-06 hover:bg-white"
                />
              </div>
            </div>
            <Button text="Continue" />
          </form>
        </div>
      </div>
    </section>
  );
};

export default CtaSection;
